// Import centralized API configuration
import {
  BASE_API,
  API_VERSION,
  API_BASE_URL,
  PROXY_BASE_API,
  PROXY_API_VERSION,
  PROXY_API_BASE_URL
} from '../../../shared/config/apiConfig';

// User endpoints
export const USER_ENDPOINTS = {
  byEmail: (email) => `${API_BASE_URL}/users/email/${email}`,
  byOrganization: (orgId) => `${API_BASE_URL}/users/organization/${orgId}`,
  organizationMembers: (orgId) => `${API_BASE_URL}/users/organizations/${orgId}/members`,
  updateMemberRole: (orgId, userId, roleId) => `${API_BASE_URL}/users/organizations/${orgId}/members/${userId}/role/${roleId}`,
  updateMemberDetails: (orgId, userId) => `${API_BASE_URL}/users/organizations/${orgId}/members/${userId}`,
  removeMember: (orgId, userId) => `${API_BASE_URL}/users/organizations/${orgId}/members/${userId}`,
  batchUpdate: (orgId) => `${API_BASE_URL}/users/organizations/${orgId}/members/batch-update`
};

//{{base_url}}{{api_path}}/{{organization_id}}/{{member_id}}/role/{{role_id}}
//update member role
 

// Role endpoints
export const ROLE_ENDPOINTS = {
  all: (orgId) => `${API_BASE_URL}/roles/all/${orgId}`,
  active: (orgId) => `${API_BASE_URL}/roles/active/${orgId}`,
  create: `${API_BASE_URL}/roles/structured`,
  withPermissions: (orgId, roleId) => `${API_BASE_URL}/roles/structured/${orgId}/${roleId}`,
  createDefault: (orgId) => `${API_BASE_URL}/roles/default/${orgId}`,
  update: (orgId, roleId) => `${API_BASE_URL}/roles/${orgId}/${roleId}`,
  delete: (orgId, roleId) => `${API_BASE_URL}/roles/${orgId}/${roleId}`
};

// Division endpoints
export const DIVISION_ENDPOINTS = {
  byOrganization: (orgId) => `${API_BASE_URL}/divisions/organizations/${orgId}`,
  create: `${API_BASE_URL}/divisions`,
  update: (divId) => `${API_BASE_URL}/divisions/${divId}`,
  delete: (divId) => `${API_BASE_URL}/divisions/${divId}`,
  members: (divId) => `${API_BASE_URL}/users/divisions/${divId}/users`
};

// Group/Team endpoints
export const GROUP_ENDPOINTS = {
  byOrganization: (orgId) => `${API_BASE_URL}/groups/organizations/${orgId}`,
  byDivision: (divId) => `${API_BASE_URL}/groups/divisions/${divId}`,
  standalone: (orgId) => `${API_BASE_URL}/groups/standalone/${orgId}`,
  create: `${API_BASE_URL}/groups`,
  createChild: `${API_BASE_URL}/groups/child`,
  update: (groupId) => `${API_BASE_URL}/groups/${groupId}`,
  delete: (groupId) => `${API_BASE_URL}/groups/${groupId}`,
  children: (parentGroupId) => `${API_BASE_URL}/groups/${parentGroupId}/children`,
  members: (groupId) => `${API_BASE_URL}/users/groups/${groupId}/users`
};

// Organization endpoints
export const ORGANIZATION_ENDPOINTS = {
  updateTheme: (orgId) => `${API_BASE_URL}/organisations/${orgId}`,
  getTheme: (orgId) => `${API_BASE_URL}/organisations/${orgId}`,
  getDetails: (orgId) => `${API_BASE_URL}/organisations/${orgId}`,
  update: (orgId) => `${API_BASE_URL}/organisations/${orgId}`
};

// Invitation endpoints
export const INVITATION_ENDPOINTS = {
  create: `${API_BASE_URL}/invitations`,
  byEmail: (email) => `${API_BASE_URL}/invitations/email/${email}`,
  list: `${API_BASE_URL}/invitations`,
  accept: (token) => `${API_BASE_URL}/invitations/accept/${token}`,
  delete:(invitationId) => `${API_BASE_URL}/invitations/${invitationId}`,
};

// Notifications endpoints
export const NOTIFICATION_ENDPOINTS = {
  create: (userId) =>  `${API_BASE_URL}/notification/users/${userId}/notifications`,
  getAll: (userId) =>  `${API_BASE_URL}/notification/users/${userId}/notifications`,
  getAllUnread: (userId) =>  `${API_BASE_URL}/notification/users/${userId}/notifications?unreadOnly=true`,
  markAsRead: (userId, notificationId) =>  `${API_BASE_URL}/notification/users/${userId}/notifications/${notificationId}/read`, //put
  markAllAsRead: (userId) => `${API_BASE_URL}/notification/users/${userId}/notifications/read-all`,
  delete: (userId, notificationId) =>  `${API_BASE_URL}/notification/users/${userId}/notifications/${notificationId}`,
};